import React from 'react';
import { useAudio } from '../hooks/useAudio';

export default function Transport() {
    const { isRunning, startEngine, stopEngine } = useAudio();

    return (
        <div className="h-full flex flex-col gap-4 p-4 bg-[#1a1a1a] rounded border border-white/5 shadow-inner">
            <div className="flex-1 grid grid-cols-3 gap-3">
                {/* PLAY */}
                <button
                    onClick={startEngine}
                    className={`relative group rounded flex flex-col items-center justify-center transition-all duration-100 ${isRunning
                        ? 'bg-[#111] shadow-[inset_0_2px_5px_black] border-t-black border-b-white/5 translate-y-[2px]'
                        : 'bg-gradient-to-b from-[#333] to-[#222] shadow-[0_4px_8px_black,inset_0_1px_0_rgba(255,255,255,0.1)] -translate-y-[2px]'
                        }`}
                >
                    <div className={`w-3 h-3 rounded-full mb-2 shadow-inner transition-colors duration-200 ${isRunning ? 'bg-[#00ff00] shadow-[0_0_10px_#00ff00]' : 'bg-[#1a331a]'
                        }`} />
                    <span className={`text-[9px] font-bold font-mono tracking-widest ${isRunning ? 'text-green-500' : 'text-gray-400'}`}>
                        PLAY
                    </span>
                </button>

                {/* STOP (New) */}
                <button
                    onClick={stopEngine}
                    className={`relative group rounded flex flex-col items-center justify-center transition-all duration-100 ${!isRunning
                        ? 'bg-[#111] shadow-[inset_0_2px_5px_black] border-t-black border-b-white/5 translate-y-[2px]'
                        : 'bg-gradient-to-b from-[#333] to-[#222] shadow-[0_4px_8px_black,inset_0_1px_0_rgba(255,255,255,0.1)] -translate-y-[2px]'
                        }`}
                >
                    <div className={`w-3 h-3 rounded-full mb-2 shadow-inner transition-colors duration-200 ${!isRunning ? 'bg-yellow-600 shadow-[0_0_5px_yellow]' : 'bg-[#332200]'
                        }`} />
                    <span className="text-[9px] font-bold font-mono tracking-widest text-gray-400">
                        STOP
                    </span>
                </button>

                {/* REC */}
                <button
                    className="relative group rounded flex flex-col items-center justify-center bg-gradient-to-b from-[#333] to-[#222] shadow-[0_4px_8px_black,inset_0_1px_0_rgba(255,255,255,0.1)] -translate-y-[2px] active:translate-y-[2px] active:bg-[#111] active:shadow-inner"
                >
                    <div className="w-3 h-3 rounded-full mb-2 bg-[#330000] shadow-inner group-active:bg-red-600 group-active:shadow-[0_0_10px_red]" />
                    <span className="text-[9px] font-bold font-mono tracking-widest text-gray-400 group-active:text-red-500">
                        REC
                    </span>
                </button>
            </div>

            {/* Time Display */}
            <div className="h-12 bg-black border border-white/10 rounded flex items-center justify-between px-3 relative overflow-hidden">
                <div className="font-mono text-xl text-green-500 drop-shadow-[0_0_5px_rgba(0,255,0,0.5)]">
                    {isRunning ? 'PLAYING >' : 'STOPPED'}
                </div>
                <div className="text-sm font-bold text-red-500 animate-pulse absolute bottom-3 right-3 bg-black/80 px-2 rounded border border-red-900">
                    VERIFIED v3.0
                </div>
            </div>
        </div>
    );
}
